import Vue from "vue"
import Vuetify from "vuetify/lib"
import colors from "vuetify/lib/util/colors"
import i18n from "@/lang/lang"

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  theme: {
    themes: {
      light: {
        primary: "#e67339", // #E53935
        secondary: colors.red.lighten4, // #FFCDD2
        accent: colors.indigo.base, // #3F51B5
        lightGray: "#B4B9BE"
      }
    }
  }
})
